export const exportHack = ({ component, constants, }) => {
    Object
        .entries(constants)
        .forEach(([key, value,]) => {
        // This expect error is in a safe place. We will still have type safety everywhere else.
        // @ts-expect-error 7054
        component[key] = value;
    });
    // Normally using `as` can be dangerous. Here gives us type safety because we're saying that this is the return type (because this doesn't currently exist).
    return component;
};
